import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import './styles.scss';
import Toggle from '../Toggle';
import '../BoxWithCollapse/styles.scss';

const SwitchButton = ({ preferencesConfirmed, onActivateChange }) => {
  const [checked, setChecked] = useState(false);
  const { t } = useTranslation('account');

  useEffect(() => {
    setChecked(preferencesConfirmed);
  }, [preferencesConfirmed]);

  const isActive = checked ? t('cookieModals.analyticsActivated') : t('cookieModals.analyticsDeactivated');

  const handleChange = checked => {
    setChecked(checked);
  };

  return (
    <label className="switch-button-label">
      <span className="indicator-small-text">{isActive}</span>
      <Toggle
        onChange={ev => {
          handleChange(ev.target.checked);
          onActivateChange(ev.target.checked);
        }}
        value={checked}
      />
    </label>
  );
};

export default SwitchButton;
